import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shuffle, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const JOKES = [
  // Animals (50 jokes)
  { q: "Why don't scientists trust atoms?", a: "Because they make up everything!" },
  { q: "What do you call a bear with no teeth?", a: "A gummy bear!" },
  { q: "What do you call a sleeping dinosaur?", a: "A dino-snore!" },
  { q: "Why do cows wear bells?", a: "Because their horns don't work!" },
  { q: "What do you call a dog that does magic?", a: "A Labracadabrador!" },
  { q: "Why don't oysters share?", a: "Because they're shellfish!" },
  { q: "What do you call a pig that knows karate?", a: "A pork chop!" },
  { q: "Why do seagulls fly over the sea?", a: "Because if they flew over the bay, they'd be bagels!" },
  { q: "What do you call a fish wearing a crown?", a: "A king fish!" },
  { q: "Why are frogs so happy?", a: "They eat whatever bugs them!" },
  { q: "What do you call a lazy kangaroo?", a: "A pouch potato!" },
  { q: "What do you call a cow with no legs?", a: "Ground beef!" },
  { q: "Why couldn't the leopard play hide and seek?", a: "Because he was always spotted!" },
  { q: "What do you call a fish with no eyes?", a: "Fsh!" },
  { q: "What do you call an alligator in a vest?", a: "An investigator!" },
  { q: "Why do bees have sticky hair?", a: "Because they use honeycombs!" },
  { q: "What do you call a deer with no eyes?", a: "No idea!" },
  { q: "Why don't elephants use computers?", a: "They're afraid of the mouse!" },
  { q: "What do you call a snake that works for the government?", a: "A civil serpent!" },
  { q: "Why do birds fly south for the winter?", a: "Because it's too far to walk!" },
  { q: "What do you call a monkey at the North Pole?", a: "Lost!" },
  { q: "Why did the chicken join a band?", a: "Because it had the drumsticks!" },
  { q: "What do you call a cat that gets anything it wants?", a: "Purrr-suasive!" },
  { q: "Why do ducks have tail feathers?", a: "To cover their butt quacks!" },
  { q: "What do you call a sheep with no legs?", a: "A cloud!" },
  { q: "Why did the spider go to the computer?", a: "To check his web site!" },
  { q: "What do you call a rabbit with fleas?", a: "Bugs Bunny!" },
  { q: "Why do pandas like old movies?", a: "Because they're in black and white!" },
  { q: "What do you call a horse that lives next door?", a: "A neigh-bor!" },
  { q: "Why did the octopus beat the shark in a fight?", a: "Because it was well armed!" },
  { q: "What do you call a penguin in the desert?", a: "Lost!" },
  { q: "Why do cows go to New York?", a: "To see the moosicals!" },
  { q: "What do you call a dinosaur that crashes their car?", a: "Tyrannosaurus Wrecks!" },
  { q: "Why did the turtle cross the road?", a: "To get to the Shell station!" },
  { q: "What do you call a dog magician?", a: "A Labracadabrador!" },
  { q: "Why don't cats play poker in the jungle?", a: "Too many cheetahs!" },
  { q: "What do you call a fly without wings?", a: "A walk!" },
  { q: "Why did the bee get married?", a: "Because he found his honey!" },
  { q: "What do you call a dinosaur that knows a lot of words?", a: "A thesaurus!" },
  { q: "Why do fish live in salt water?", a: "Because pepper makes them sneeze!" },
  { q: "What do you call a pig that does karate?", a: "A pork chop!" },
  { q: "Why do gorillas have big nostrils?", a: "Because they have big fingers!" },
  { q: "What do you call a crocodile that likes bowling?", a: "An alley-gator!" },
  { q: "Why did the cow go to outer space?", a: "To visit the Milky Way!" },
  { q: "What do you call a camel with no humps?", a: "Humphrey!" },
  { q: "Why are fish so smart?", a: "Because they live in schools!" },
  { q: "What do you call a grumpy cow?", a: "Mooo-dy!" },
  { q: "Why did the elephant paint itself different colors?", a: "So it could hide in the crayon box!" },
  { q: "What do you call a parrot that flew away?", a: "A polygon!" },
  { q: "Why do hummingbirds hum?", a: "Because they don't know the words!" },

  // Food (50 jokes)
  { q: "What did the grape say when it got stepped on?", a: "Nothing, it just let out a little wine!" },
  { q: "Why did the cookie go to the doctor?", a: "Because it was feeling crummy!" },
  { q: "What do you call cheese that isn't yours?", a: "Nacho cheese!" },
  { q: "Why did the banana go to the doctor?", a: "It wasn't peeling well!" },
  { q: "What do you call a sad strawberry?", a: "A blueberry!" },
  { q: "Why did the tomato turn red?", a: "Because it saw the salad dressing!" },
  { q: "What's a potato's favorite form of transportation?", a: "The gravy train!" },
  { q: "Why did the coffee file a police report?", a: "It got mugged!" },
  { q: "What do you call a peanut in a spacesuit?", a: "An astronut!" },
  { q: "Why did the lemon stop rolling?", a: "It ran out of juice!" },
  { q: "What do you call fake spaghetti?", a: "An impasta!" },
  { q: "Why don't eggs tell jokes?", a: "They'd crack each other up!" },
  { q: "What's orange and sounds like a parrot?", a: "A carrot!" },
  { q: "Why did the melon jump into the lake?", a: "It wanted to be a watermelon!" },
  { q: "What do you call a lazy spud?", a: "A couch potato!" },
  { q: "Why did the apple go to the doctor?", a: "It wasn't peeling very well!" },
  { q: "What do you call a sleeping pizza?", a: "A piZZZZa!" },
  { q: "Why did the baker stop making donuts?", a: "He was tired of the hole business!" },
  { q: "What do you call a sandwich that you sleep on?", a: "A sub-dream!" },
  { q: "Why did the orange lose the race?", a: "It ran out of juice!" },
  { q: "What do you call a nervous hot dog?", a: "A frankfurter!" },
  { q: "Why did the cabbage win the race?", a: "Because it was ahead!" },
  { q: "What's a ghost's favorite fruit?", a: "Booberries!" },
  { q: "Why did the teddy bear say no to dessert?", a: "Because she was already stuffed!" },
  { q: "What do you call a fake noodle?", a: "An impasta!" },
  { q: "Why did the mushroom go to the party?", a: "Because he was a fungi!" },
  { q: "What did the hamburger name its baby?", a: "Patty!" },
  { q: "Why do bananas wear sunscreen?", a: "Because they peel!" },
  { q: "What do you call a grilled cheese sandwich that's all up in your face?", a: "Too close for comfort food!" },
  { q: "Why did the corn stalk get angry?", a: "Someone was pulling its ear!" },
  { q: "What do you call a sad coffee?", a: "Depresso!" },
  { q: "Why did the jelly wobble?", a: "Because it saw the milk shake!" },
  { q: "What do you call an avocado that's been blessed?", a: "Holy guacamole!" },
  { q: "Why are eggs so good at telling jokes?", a: "They always crack people up!" },
  { q: "What did the hungry computer eat?", a: "Chips - one byte at a time!" },
  { q: "Why did the yogurt go to the museum?", a: "Because it was cultured!" },
  { q: "What do you call a tired pea?", a: "Sleep-pea!" },
  { q: "Why did the bread break up with the butter?", a: "It found someone butter!" },
  { q: "What do you call a fancy fish dish?", a: "Sofishticated!" },
  { q: "Why did the pepper put on a sweater?", a: "It was a little chili!" },
  { q: "What did the lettuce say to the celery?", a: "Quit stalking me!" },
  { q: "Why did the cookie cry?", a: "Because its mother was a wafer so long!" },
  { q: "What do you call cheese that's not yours?", a: "Nacho cheese!" },
  { q: "Why did the meatball go to the party?", a: "Because it was on a roll!" },
  { q: "What did the ocean say to the sandwich?", a: "Nothing, it just waved!" },
  { q: "Why did the can crusher quit his job?", a: "Because it was soda pressing!" },
  { q: "What do you call a pasta that fights crime?", a: "Spaghetti Western!" },
  { q: "Why did the salad go to the gym?", a: "To get shredded!" },
  { q: "What do you call a sleeping vegetable?", a: "A rest-aurant!" },
  { q: "Why did the cake go to the doctor?", a: "It was feeling crumby!" },

  // School & Learning (50 jokes)
  { q: "Why did the student eat his homework?", a: "Because his teacher said it was a piece of cake!" },
  { q: "Why did the math book look so sad?", a: "Because it had so many problems!" },
  { q: "What's a snake's favorite subject?", a: "Hissssstory!" },
  { q: "Why was the geometry book so adorable?", a: "Because it had acute angles!" },
  { q: "What did the pen say to the pencil?", a: "You're looking sharp!" },
  { q: "Why can't you give Elsa a balloon?", a: "Because she'll let it go!" },
  { q: "What's a computer's favorite snack?", a: "Microchips!" },
  { q: "Why was 6 afraid of 7?", a: "Because 7, 8, 9!" },
  { q: "What did zero say to eight?", a: "Nice belt!" },
  { q: "Why is 1+1=3 like your left foot?", a: "It's not right!" },
  { q: "Why did the teacher wear sunglasses?", a: "Because her students were so bright!" },
  { q: "What's a math teacher's favorite tree?", a: "Geometry!" },
  { q: "Why did the music teacher need a ladder?", a: "To reach the high notes!" },
  { q: "What do you call a teacher who never farts in public?", a: "A private tutor!" },
  { q: "Why did the book join the police?", a: "It wanted to go undercover!" },
  { q: "What's a pencil's favorite place to go?", a: "Pennsylvania!" },
  { q: "Why did the eraser go to school?", a: "To correct its mistakes!" },
  { q: "What do librarians take with them when they go fishing?", a: "Bookworms!" },
  { q: "Why did the clock go to the principal's office?", a: "For tocking too much!" },
  { q: "What's a witch's favorite subject in school?", a: "Spelling!" },
  { q: "Why did the kid bring a ladder to school?", a: "He wanted to go to high school!" },
  { q: "What did the calculator say to the student?", a: "You can count on me!" },
  { q: "Why did the nose not want to go to school?", a: "It was tired of being picked on!" },
  { q: "What's a pirate's favorite letter?", a: "You'd think it's R, but it's the C!" },
  { q: "Why did the bicycle fall asleep in class?", a: "It was two-tired!" },
  { q: "What do elves learn in school?", a: "The elf-abet!" },
  { q: "Why did the scientist take out his doorbell?", a: "He wanted to win the No-bell prize!" },
  { q: "What do you call a happy classroom?", a: "A high school!" },
  { q: "Why did the student throw his watch out the window?", a: "He wanted to see time fly!" },
  { q: "What's a tornado's favorite game to play?", a: "Twister!" },
  { q: "Why did the ruler go to the doctor?", a: "Because it wasn't measuring up!" },
  { q: "What's the king of all school supplies?", a: "The ruler!" },
  { q: "Why did the teacher draw on the window?", a: "Because she wanted the lesson to be very clear!" },
  { q: "What do you get when you cross a teacher with a vampire?", a: "Lots of blood tests!" },
  { q: "Why did the kid eat his homework?", a: "His teacher said it was a piece of cake!" },
  { q: "What's a vampire's favorite subject?", a: "Fang-lish!" },
  { q: "Why did the student sit on a clock?", a: "To be on time!" },
  { q: "What do you call a dinosaur with an extensive vocabulary?", a: "A thesaurus!" },
  { q: "Why did the gym teacher go to the bank?", a: "To check his balance!" },
  { q: "What's the best place to grow flowers in school?", a: "In kindergarten!" },
  { q: "Why did the alphabet go to the gym?", a: "To work on its A-B-C muscles!" },
  { q: "What do you get when you divide the circumference of a jack-o-lantern by its diameter?", a: "Pumpkin Pi!" },
  { q: "Why did the geography student drown?", a: "His grades were below C level!" },
  { q: "What school do you have to drop out of to graduate from?", a: "Parachute school!" },
  { q: "Why did the student do multiplication on the floor?", a: "The teacher told him not to use tables!" },
  { q: "What's an astronaut's favorite key on the keyboard?", a: "The space bar!" },
  { q: "Why did the picture go to jail?", a: "Because it was framed!" },
  { q: "What did the science book say to the math book?", a: "You've got problems!" },
  { q: "Why did the kid cross the playground?", a: "To get to the other slide!" },
  { q: "What did the paper say to the pencil?", a: "Write on!" },

  // Nature & Weather (50 jokes)
  { q: "What did the ocean say to the beach?", a: "Nothing, it just waved!" },
  { q: "What do clouds wear under their shorts?", a: "Thunderpants!" },
  { q: "Why did the sun go to school?", a: "To get a little brighter!" },
  { q: "What's a tornado's favorite game?", a: "Twister!" },
  { q: "How do trees access the internet?", a: "They log in!" },
  { q: "What did the volcano say to its true love?", a: "I lava you!" },
  { q: "Why did the leaf go to the doctor?", a: "It was feeling green!" },
  { q: "What kind of tree fits in your hand?", a: "A palm tree!" },
  { q: "What do you call a snowman in summer?", a: "A puddle!" },
  { q: "Why is grass so dangerous?", a: "Because it's full of blades!" },
  { q: "What falls but never gets hurt?", a: "Rain!" },
  { q: "What's the best day to go to the beach?", a: "Sun-day!" },
  { q: "Why did the raindrop go to the doctor?", a: "It was feeling under the weather!" },
  { q: "What did one lightning bolt say to the other?", a: "You're shocking!" },
  { q: "Why did the tree go to the dentist?", a: "It needed a root canal!" },
  { q: "What did the big flower say to the little flower?", a: "Hi there, bud!" },
  { q: "Why do rivers never get lost?", a: "They always follow their current!" },
  { q: "What did the ground say to the earthquake?", a: "You crack me up!" },
  { q: "Why did the gardener plant lightbulbs?", a: "He wanted a power plant!" },
  { q: "What's a mountain's favorite type of candy?", a: "Snow caps!" },
  { q: "Why did the sun break up with the moon?", a: "It needed more space!" },
  { q: "What do you call a wet bear?", a: "A drizzly bear!" },
  { q: "Why did the cloud break up with the fog?", a: "The relationship was too misty!" },
  { q: "What's the wind's favorite color?", a: "Blew!" },
  { q: "Why did the flower ride a bike?", a: "It wanted to pedal its petals!" },
  { q: "What do you call flowers when they're best friends?", a: "Buds!" },
  { q: "Why do hurricanes travel so fast?", a: "Because if they traveled slowly, they'd be called slow-i-canes!" },
  { q: "What did the tree say to spring?", a: "What a re-leaf!" },
  { q: "Why did the pine tree get into trouble?", a: "Because it was being knotty!" },
  { q: "What's a bee's favorite flower?", a: "A bee-gonia!" },
  { q: "Why did the rock go to school?", a: "To become a little boulder!" },
  { q: "What do you call a frozen dessert made by a weather reporter?", a: "A forecast!" },
  { q: "Why did the puddle get an award?", a: "For being outstanding in its field!" },
  { q: "What did the rain say to the ground?", a: "If I keep falling for you, we'll have to get together!" },
  { q: "Why don't trees like riddles?", a: "They're stumped by them!" },
  { q: "What's a cloud's favorite drink?", a: "Mountain dew!" },
  { q: "Why did the snowman call his dog Frost?", a: "Because Frost bites!" },
  { q: "What do you call it when it rains chickens and ducks?", a: "Fowl weather!" },
  { q: "Why did the rainbow go to jail?", a: "Because it was a repeat offender - it kept showing up after the storm!" },
  { q: "What's a tree's favorite drink?", a: "Root beer!" },
  { q: "Why did the grass go to the movies?", a: "Because it heard the film was a real thriller!" },
  { q: "What did the seed say to the flower?", a: "OK, bloomer!" },
  { q: "Why do flowers never drive?", a: "They keep losing their petals!" },
  { q: "What did the ocean say to the sailboat?", a: "Nothing, it just waved!" },
  { q: "Why are mountains so funny?", a: "They're hill-arious!" },
  { q: "What do you call dangerous precipitation?", a: "A rain of terror!" },
  { q: "Why did the star go to school?", a: "To be a little brighter!" },
  { q: "What's a cat's favorite weather?", a: "When it's raining cats and dogs!" },
  { q: "Why did the frost go to art school?", a: "It wanted to learn how to draw windows!" },
  { q: "What do you call a lazy rainbow?", a: "A plainbow!" },

  // Silly Wordplay (50 jokes)
  { q: "What do you call a boomerang that doesn't come back?", a: "A stick!" },
  { q: "Why can't your nose be 12 inches long?", a: "Because then it would be a foot!" },
  { q: "What has ears but cannot hear?", a: "A cornfield!" },
  { q: "What has hands but can't clap?", a: "A clock!" },
  { q: "What can you catch but not throw?", a: "A cold!" },
  { q: "What gets wetter the more it dries?", a: "A towel!" },
  { q: "What has a head and a tail but no body?", a: "A coin!" },
  { q: "What goes up but never comes down?", a: "Your age!" },
  { q: "What can travel around the world while staying in a corner?", a: "A stamp!" },
  { q: "What has teeth but cannot bite?", a: "A comb!" },
  { q: "Why did the scarecrow win an award?", a: "Because he was outstanding in his field!" },
  { q: "Why did the bicycle fall over?", a: "Because it was two-tired!" },
  { q: "What did one wall say to the other?", a: "I'll meet you at the corner!" },
  { q: "Why did the belt go to jail?", a: "Because it held up a pair of pants!" },
  { q: "What do you call a train that sneezes?", a: "Achoo-choo train!" },
  { q: "Why did the balloon go near the needle?", a: "It wanted to be a pop star!" },
  { q: "What do you call a shoe made from a banana?", a: "A slipper!" },
  { q: "Why did the robber take a bath?", a: "He wanted to make a clean getaway!" },
  { q: "What do you call a sleeping bull?", a: "A bull-dozer!" },
  { q: "Why did the golfer wear two pairs of pants?", a: "In case he got a hole in one!" },
  { q: "What do you call a funny mountain?", a: "Hill-arious!" },
  { q: "Why did the invisible man turn down the job offer?", a: "He couldn't see himself doing it!" },
  { q: "What do you call a number that can't keep still?", a: "A roaming numeral!" },
  { q: "Why did the lamp go to school?", a: "Because it wasn't too bright!" },
  { q: "What do you call a magic dog?", a: "A Labra-cadabra-dor!" },
  { q: "Why don't skeletons fight each other?", a: "They don't have the guts!" },
  { q: "What do you call a deer with absolutely no eyes?", a: "No eye-deer!" },
  { q: "Why did the computer go to the doctor?", a: "Because it had a virus!" },
  { q: "What do you call a bear with no ears?", a: "B!" },
  { q: "Why did the rope go to the party?", a: "To tie one on!" },
  { q: "What has four wheels and flies?", a: "A garbage truck!" },
  { q: "Why did the traffic light turn red?", a: "You would too if you had to change in the middle of the street!" },
  { q: "What do you call a fairy that hasn't taken a bath?", a: "Stinker Bell!" },
  { q: "Why can't you trust stairs?", a: "They're always up to something!" },
  { q: "What do you call a dinosaur that is sleeping?", a: "A dino-snore!" },
  { q: "Why did the toilet paper roll down the hill?", a: "To get to the bottom!" },
  { q: "What do you call a cow that can't moo?", a: "A milk dud!" },
  { q: "Why did the golfer bring an extra pair of socks?", a: "In case he got a hole in one!" },
  { q: "What's the best way to watch a fly fishing tournament?", a: "Live stream!" },
  { q: "What do you call a blind dinosaur?", a: "A do-you-think-he-saw-us!" },
  { q: "Why did the photo go to jail?", a: "Because it was framed!" },
  { q: "What do you call a fish without eyes?", a: "Fsh!" },
  { q: "Why did the teddy bear skip dessert?", a: "Because she was already stuffed!" },
  { q: "What do you call a group of musical whales?", a: "An orca-stra!" },
  { q: "Why did the stadium get hot?", a: "All the fans left!" },
  { q: "What do you call a fake stone in Ireland?", a: "A sham rock!" },
  { q: "Why did the nose feel bad?", a: "It was tired of being picked on!" },
  { q: "What do you call a sleeping dinosaur?", a: "A dino-snore!" },
  { q: "Why did the orange stop?", a: "It ran out of juice!" },
  { q: "What do you call an elephant that doesn't matter?", a: "Irrelephant!" },

  // Occupations & People (50 jokes)
  { q: "Why did the doctor carry a red pen?", a: "In case they needed to draw blood!" },
  { q: "What did the dentist say to the golfer?", a: "You have a hole in one!" },
  { q: "Why did the astronaut break up with his girlfriend?", a: "He needed more space!" },
  { q: "What do you call a judge with no thumbs?", a: "Justice fingers!" },
  { q: "Why did the policeman go to the baseball game?", a: "He heard someone was stealing bases!" },
  { q: "What did the plumber say to the singer?", a: "Nice pipes!" },
  { q: "Why did the fireman wear red suspenders?", a: "To keep his pants up!" },
  { q: "What do you call a sleeping doctor?", a: "A coma-tose!" },
  { q: "Why did the chef win the argument?", a: "He made some valid points!" },
  { q: "What do you call a funny criminal?", a: "A pun-isher!" },
  { q: "Why did the baker go to therapy?", a: "He had too many loaf issues!" },
  { q: "What did the coach say to the broken vending machine?", a: "Give me my quarterback!" },
  { q: "Why did the artist go to jail?", a: "Because she was framed!" },
  { q: "What do you call a lazy painter?", a: "A little sketchy!" },
  { q: "Why did the musician get arrested?", a: "For fingering A minor!" },
  { q: "What did the janitor say when he jumped out of the closet?", a: "Supplies!" },
  { q: "Why did the librarian slip and fall?", a: "She was in the non-friction section!" },
  { q: "What do you call a clumsy spy?", a: "A trip agent!" },
  { q: "Why did the banker quit his job?", a: "He lost interest!" },
  { q: "What did the carpet installer say?", a: "I've got this covered!" },
  { q: "Why did the electrician become a teacher?", a: "He wanted to enlighten people!" },
  { q: "What do you call a nervous zookeeper?", a: "A bit antsy!" },
  { q: "Why did the actor fall through the floorboards?", a: "He was going through a stage!" },
  { q: "What did the magician say to the fisherman?", a: "Pick a cod, any cod!" },
  { q: "Why did the carpenter get lost?", a: "He couldn't find the board!" },
  { q: "What do you call a pilot who's always late?", a: "Tardy-grade!" },
  { q: "Why did the reporter go to the ice cream shop?", a: "To get the scoop!" },
  { q: "What did the vet say after examining the dog?", a: "Nothing, it was just a ruff day!" },
  { q: "Why did the farmer win an award?", a: "He was outstanding in his field!" },
  { q: "What do you call a royal barber?", a: "A crown cutter!" },
  { q: "Why did the astronaut use a computer?", a: "To update his space bar!" },
  { q: "What did the coach say to the piggy bank?", a: "Ready to make some savings plays!" },
  { q: "Why did the mail carrier become a singer?", a: "She had great delivery!" },
  { q: "What do you call a sad photographer?", a: "Negative!" },
  { q: "Why did the tailor win the race?", a: "He was sew fast!" },
  { q: "What did the butcher say to the customer?", a: "Nice to meat you!" },
  { q: "Why did the lifeguard kick the elephants out of the pool?", a: "They kept dropping their trunks!" },
  { q: "What do you call a dinosaur that sells cars?", a: "A tyrannosaurus-salesman!" },
  { q: "Why did the programmer quit his job?", a: "He didn't get arrays!" },
  { q: "What did the florist say to the customer?", a: "I'm so glad you picked me!" },
  { q: "Why did the volleyball player join the navy?", a: "She wanted to serve her country!" },
  { q: "What do you call a teacher who doesn't fart in class?", a: "A private tutor!" },
  { q: "Why did the clown go to the doctor?", a: "He was feeling a little funny!" },
  { q: "What did the mountain climber name his son?", a: "Cliff!" },
  { q: "Why did the baseball player bring a ladder?", a: "He wanted to hit a fly ball!" },
  { q: "What do you call a funny magician?", a: "A prankster!" },
  { q: "Why did the skeleton go to the party alone?", a: "He had no body to go with him!" },
  { q: "What did the coach shout at the broken vending machine?", a: "Give me my quarter back!" },
  { q: "Why did the gym close down?", a: "It just didn't work out!" },
  { q: "What do you call a magician who lost his magic?", a: "Ian!" }
];

const GiggleGeneratorPremium = () => {
  const navigate = useNavigate();
  const [currentJoke, setCurrentJoke] = useState(() => JOKES[Math.floor(Math.random() * JOKES.length)]);
  const [showAnswer, setShowAnswer] = useState(false);
  const [seenJokes, setSeenJokes] = useState(() => new Set([currentJoke.q]));

  const getRandomJoke = () => {
    let newJoke = JOKES[Math.floor(Math.random() * JOKES.length)];
    while (newJoke.q === currentJoke.q && JOKES.length > 1) {
      newJoke = JOKES[Math.floor(Math.random() * JOKES.length)];
    }
    setCurrentJoke(newJoke);
    setShowAnswer(false);
    setSeenJokes(prev => (prev.has(newJoke.q) ? prev : new Set(prev).add(newJoke.q)));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF9E3] via-[#FFE66D] to-[#FFD700] relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-orange-400 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-amber-300 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 py-8">
        <header className="flex justify-between items-center mb-8">
          <button
            data-testid="back-to-dashboard"
            onClick={() => navigate('/dashboard')}
            className="bg-white text-[#2D3748] px-6 py-3 rounded-full font-semibold hover:bg-slate-100 transition-all duration-300 flex items-center gap-2 shadow-sm"
          >
            <ArrowLeft className="w-5 h-5" />
            Back
          </button>
          
          <h1 className="text-3xl md:text-4xl font-bold text-[#2D3748]">Giggle Generator</h1>
          
          <button
            data-testid="new-joke-btn"
            onClick={getRandomJoke}
            className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:-translate-y-1 transition-all duration-300 shadow-lg flex items-center gap-2"
          >
            <Shuffle className="w-5 h-5" />
            New Joke
          </button>
        </header>

        <div className="text-center mb-4">
          <span className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-5 py-2 rounded-full text-sm font-bold inline-flex items-center gap-2 shadow-lg">
            <Star className="w-4 h-4 fill-current" />
            Premium - 300 Jokes
            <Star className="w-4 h-4 fill-current" />
          </span>
        </div>

        <motion.div
          key={currentJoke.q}
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="bg-white rounded-3xl p-12 shadow-2xl border-2 border-amber-200 text-center"
        >
          <div className="text-6xl mb-8">
            {showAnswer ? "🤣" : "😄"}
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D3748] mb-8 leading-relaxed">
            {currentJoke.q}
          </h2>
          
          {!showAnswer ? (
            <button
              data-testid="show-answer-btn"
              onClick={() => setShowAnswer(true)}
              className="bg-gradient-to-r from-amber-400 to-orange-400 text-white px-12 py-4 rounded-full font-bold text-lg hover:-translate-y-1 transition-all duration-300 shadow-lg"
            >
              Show Answer
            </button>
          ) : (
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
            >
              <div className="text-xl md:text-2xl font-semibold text-amber-600 p-6 bg-amber-50 rounded-2xl mb-6 border border-amber-200">
                {currentJoke.a}
              </div>
              <button
                onClick={getRandomJoke}
                className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-8 py-3 rounded-full font-semibold hover:-translate-y-1 transition-all duration-300 shadow-lg flex items-center gap-2 mx-auto"
              >
                <Shuffle className="w-5 h-5" />
                Another One!
              </button>
            </motion.div>
          )}
        </motion.div>

        <div className="mt-8 text-center">
          <p className="text-[#2D3748] font-medium">
            ⭐ 300 hilarious jokes to keep you giggling! You've seen {Math.min(seenJokes.size, JOKES.length)} so far.
          </p>
          <div className="mt-4 flex justify-center gap-2 flex-wrap">
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">🐾 Animals</span>
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">🍕 Food</span>
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">📚 School</span>
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">🌿 Nature</span>
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">😜 Wordplay</span>
            <span className="bg-white/80 px-3 py-1 rounded-full text-sm text-[#4A5568]">👷 Jobs</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiggleGeneratorPremium;
